import { langSegment } from '@tmf-ui-routes/i18n-segments/lang-segment.i18n-segment';
import { userSettingsI18nSegment } from '@tmf-ui-routes/i18n-segments/user-settings.i18n-segment';

export function userSettingsRoutePath(): string {
  return `/${langSegment()}/${userSettingsI18nSegment()}/`;
}
